import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../components/Loader";
import { crmHeaders } from "../../utils/crmApi";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function DeleteSmsTemplate() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [template, setTemplate] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get(`${BASE_URL}/sms/templates`, { headers: crmHeaders() })
            .then((res) => {
                const found = res.data.find((t) => String(t.Id) === String(id));
                setTemplate(found || null);
            })
            .finally(() => setLoading(false));
    }, [id]);

    const handleDelete = () => {
        axios
            .delete(`${BASE_URL}/sms/templates/${id}`, { headers: crmHeaders() })
            .then(() => {
                toast.success("Template deleted");
                navigate("/sms/templates");
            })
            .catch((err) => toast.error(err.response?.data?.message || "Delete failed"));
    };

    if (loading) return <Loader />;

    return (
        <div className="container">
            <ToastContainer />
            <h2>Delete SMS Template</h2>
            {template ? (
                <>
                    <p>
                        Delete template for <strong>{template.Country}</strong>?
                    </p>
                    <pre className="bg-light p-3 rounded">{template.Template}</pre>
                    <button type="button" className="btn btn-danger me-2" onClick={handleDelete}>
                        Yes, Delete
                    </button>
                </>
            ) : (
                <p>Template not found.</p>
            )}
            <Link to="/sms/templates" className="btn btn-outline-secondary ms-2">
                Cancel
            </Link>
        </div>
    );
}
